export const GET_CLIENT_LOADING = "client_loading";
export const GET_CLIENT_SUCCESS = "client_success";
export const GET_CLIENT_FAILED = "client_failed";
